'use client';

import classNames from 'classnames';
import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { type Transform } from '../field-controller/field-controller';

import styles from './form-textarea.module.scss';

export type FormTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  errorMessageId?: string;
  hasError?: boolean;
  isRequired?: boolean;
  maxLength?: number;
  transform?: Transform;
};

export const FormTextarea = forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  (
    { className, errorMessageId, hasError, id, isRequired, onChange, transform, value, ...rest },
    ref
  ) => {
    return (
      <textarea
        aria-describedby={errorMessageId}
        aria-invalid={hasError}
        aria-required={isRequired}
        className={classNames(className, styles['form-textarea'], {
          [styles['form-textarea--has-error']]: hasError,
          [styles['form-textarea--has-value']]: Boolean(value),
        })}
        id={id}
        onChange={(event) => {
          onChange?.(transform ? transform.output(event) : event.target.value);
        }}
        ref={ref}
        value={transform ? transform.input(value) : value}
        {...rest}
      />
    );
  }
);
